var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "update_popup", attrs: { id: "wrap" } }, [
    _c("h1", [_vm._v("KOLON")]),
    _vm._v(" "),
    _c("div", { staticClass: "update_cont" }, [
      _c("div", { staticClass: "cont_group" }, [
        _c("a", { staticClass: "dow_btn", attrs: { href: _vm.appUpdateUrl } }, [
          _vm.appImg
            ? _c("img", { staticClass: "app_icon", attrs: { src: _vm.appImg } })
            : _c("img", {
                attrs: { src: require("@/assets/image/ico-app-h-72.png") }
              }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.appNm))])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("위 버튼을 클릭하시어"),
          _c("br"),
          _vm._v(
            _vm._s(_vm.appNm) + "을(를) 다운로드 후 업데이트를 완료해 주세요!"
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _c("img", {
        attrs: { src: require("@/assets/image/ico-app-down-h-32.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ba6bf03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ba6bf03","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Update.vue
// module id = null
// module chunks = 